import Vue from 'vue'
import i18n from '@/i18n'

const vue = new Vue({ i18n })
export default [
    /*************************************************
    * Conversores
    *************************************************/
    {
        path: '/sistemas-internos/conversores',
        view: 'sistemas-internos/conversores/Listar',
        meta:{
            title: vue.$t("Router.SistemasInternos.conversor"),
        }    
    }                    
]
